import Vue from 'vue'
import App from './App.vue'
import router from './router'

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  let title = '璞华易研 - 企业级PLM&PMS解决方案'
  if(to.meta.title) title = `${to.meta.title}_` + title
  document.title = title
  next()
})

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI )

import "./assets/fonts/font.css"
import "./styles/mobile.scss"

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1
})

Vue.config.productionTip = false

import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

new Vue({
  router,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')

// rem：PC 仍按 1920 稿缩放；手机锁 8.5px，整体比 10px 略收一档，避免字和留白偏臃肿
const PC_MIN = 768
const MOBILE_ROOT_FONT = 8
const setHtmlFontSize = () => {
  const htmlDom = document.getElementsByTagName('html')[0]
  const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
  htmlDom.style.fontSize = htmlWidth >= PC_MIN
    ? `${htmlWidth / 1920 * 10}px`
    : `${MOBILE_ROOT_FONT}px`
}
window.addEventListener('resize', setHtmlFontSize)
setHtmlFontSize()
